import * as React from 'react';
import { Box } from "../box";
var MessageCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      width = _ref.width,
      height = _ref.height,
      backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    p: 4,
    borderRadius: "0 20px 20px 20px",
    width: width,
    height: height,
    backgroundColor: backgroundColor,
    color: color,
    sx: {
      whiteSpace: 'break-spaces',
      wordBreak: 'break-word',
      overflowWrap: 'break-word'
    },
    "data-test-id": dataTestId
  }, children);
});
MessageCard.defaultProps = {
  width: '100%',
  height: 'auto',
  backgroundColor: 'blue.200',
  color: 'grey.900',
  dataTestId: 'messageCard'
};
export default MessageCard;
export { MessageCard };